<template>
  <md-dialog
    class="DialogEscuelaSeleccionar"
    :md-active.sync="showDialogEscuelaSeleccionar"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
  >
    <md-dialog-title>¿Con que escuela estarás trabajando?</md-dialog-title>
    <md-dialog-content>
      <md-field>
        <label>Seleccionar escuela</label>
        <md-select
          v-model="id_esc"
          md-dense
          required
        >
          <md-option
            v-for="(item,index) in escuelas"
            :key="index"
            :value="index"
            :disabled="asignando"
          >
            {{item.clave_esc}}, {{item.nombre_esc}}
          </md-option>
        </md-select>
      </md-field>
      <md-field>
        <label>¿Asiste el dentista a la brigada?</label>
        <md-select
          v-model="dentista"
          md-dense
          required
        >
          <md-option value="si">Si</md-option>
          <md-option value="no">No</md-option>
        </md-select>
      </md-field>
    </md-dialog-content>
    <md-dialog-actions v-if="!asignando">
      <md-button @click="_asignar()">Asignar escuela</md-button>
    </md-dialog-actions>
    <md-progress-bar
      md-mode="indeterminate"
      v-if="asignando"
    />
  </md-dialog>
</template>
<script>
export default {
  name: "DialogEscuelaSeleccionar",
  props: { vista: String, showDialogEscuelaSeleccionar: Boolean },
  data() {
    return {
      asignando: false,
      dentista: "no",
      escuelas: [],
      id_esc: null,
      errores: {
        id_esc: null
      }
    };
  },
  methods: {
    _validate() {
      this.errores.id_esc =
        this.id_esc != null && this.id_esc >= 0 ? null : "md-invalid";
      return this.$validate(this.errores);
    },
    _asignar() {
      this.asignando = true;
      if (this._validate()) {
        this.$session.set("escuela", this.escuelas[this.id_esc].id_esc);
        this.$session.set("dentistaEnEscuela", this.dentista);
        this.$session.set(
          "escuela_nombre",
          this.escuelas[this.id_esc].nombre_esc
        );
        this.$emit("escuela", Date.now());
        this.$emit("msg", "Escuela asignada");
        this.asignando = false;
        this.showDialogEscuelaSeleccionar = false;
      } else {
        this.$emit("msg", "Seleccione una escuela");
        this.asignando = false;
      }
    }
  },
  created() {
    this.escuelas = JSON.parse(localStorage.getItem("escuelas")).sort(function(
      a,
      b
    ) {
      if (a.nombre_esc.toLowerCase() < b.nombre_esc.toLowerCase()) {
        return -1;
      }
      if (a.nombre_esc.toLowerCase() > b.nombre_esc.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    if (!this.$session.has("escuela")) {
      switch (this.vista) {
        case "PacientesForm":
          this.showDialogEscuelaSeleccionar = !this.$route.params.idPac
            ? true
            : false;
          break;
      }
    }
  },
  watch: {
    showDialogEscuelaSeleccionar(a) {
      if (!a) {
        this.escuelas = [];
        this.id_esc = null;
        this.errores.id_esc = null;
      }
    }
  }
};
</script>